<template>
  <div :class="['detail-workspace', { 'is-drawer-workspace': isDrawer }]" v-loading="loading">
    <!-- 顶部导航面包屑 -->
    <div class="breadcrumb-header">
      <div class="header-top-row" style="display: flex !important; justify-content: space-between; align-items: center; width: 100%; flex-wrap: nowrap !important; gap: 16px;">
        <div class="header-left" style="display: flex !important; align-items: center; gap: 12px; flex: 1; min-width: 0; flex-wrap: nowrap !important; flex-shrink: 1;">
          <div class="title-container" style="flex-shrink: 0; display: flex; align-items: center; gap: 10px;">
            <span class="header-title" style="font-size: 15px; font-weight: 700; white-space: nowrap;">
              <span class="header-title-icon"><i :class="isNew ? 'el-icon-plus' : 'el-icon-edit-outline'"></i></span>
              {{ isNew ? '接入新渠道' : `编辑：${form.id} - ${form.name}` }}
            </span>
            <span class="header-subtitle">步骤 {{ currentStep + 1 }} / 6 · {{ getStepName(currentStep) }}</span>
          </div>
        </div>

        <div class="header-right-buttons" style="display: flex !important; align-items: center; gap: 8px; flex-shrink: 0 !important; margin-left: auto !important; flex-wrap: nowrap !important;">
          <!-- 新增状态按钮 -->
          <template v-if="isNew">
            <el-button size="small" @click="goBack" style="flex-shrink: 0;"><i class="el-icon-back"></i> 返回列表</el-button>
            <el-button v-if="currentStep > 0" size="small" @click="prevStep" style="flex-shrink: 0;">上一步</el-button>
            <el-button v-if="currentStep < 5" type="primary" size="small" @click="nextStep" style="flex-shrink: 0;">下一步</el-button>
            <el-button v-if="currentStep === 5" type="success" size="small" @click="handleCreateChannelAndArgs" style="flex-shrink: 0;">确认创建并保存</el-button>
          </template>
          <!-- 编辑状态按钮 -->
          <template v-else>
            <el-button size="small" @click="goBack" style="flex-shrink: 0;"><i class="el-icon-back"></i> 返回列表</el-button>
            <el-button type="success" size="small" @click="handleSaveCurrentStepOnly" style="flex-shrink: 0;">保存</el-button>
          </template>
        </div>
      </div>
    </div>

    <!-- 精致的 Steps 步骤主操作面板 -->
    <div class="box wizard-steps-card">
      <div class="custom-wizard-steps flex">
        <div
          v-for="(step, idx) in steps"
          :key="idx"
          :class="['custom-step-node', { 'active': idx === currentStep, 'finished': idx <= maxReachedStep && idx !== currentStep, 'clickable': !isNew || idx <= maxReachedStep }]"
          @click="handleStepClick(idx)"
        >
          <!-- 步骤主体内容 -->
          <div class="custom-step-body">
            <div class="custom-step-number">
              <span v-if="idx <= maxReachedStep && idx !== currentStep" class="finished-check"><i class="el-icon-check"></i></span>
              <span v-else>{{ idx + 1 }}</span>
            </div>
            <div class="custom-step-card-wrapper">
              <div class="custom-step-text-box">
                <div class="custom-step-title">{{ step.title }}</div>
              </div>
            </div>
          </div>

          <!-- 虚线连接线：只放在非最后一个步骤之后，并作为 flex 项自动伸缩 -->
          <div v-if="idx < steps.length - 1" class="custom-step-line"></div>
        </div>
      </div>
    </div>

    <!-- 核心表单与步骤切换内容卡片 -->
    <div class="detail-content box">

      <!-- 步骤 1 / 基础信息 (Basic) -->
      <div v-if="currentStep === 0" class="tab-panel">
        <div class="panel-section-header" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <div class="panel-title-icon"><font-awesome-icon :icon="getStepIcon(currentStep)" /></div>
          <div style="display: flex; flex-direction: column;">
            <h3 class="panel-section-title">
              基础属性设置
            </h3>
            <p class="section-subtitle">建立渠道的基础元信息，并锁定目标包体的物理宿主属性。</p>
          </div>
        </div>

        <el-form :model="form" label-position="right" label-width="130px" :rules="rules" ref="form" size="small" class="form-container">
          <el-row :gutter="32">
            <el-col :span="24">
              <el-form-item label="游戏平台" prop="platformId">
                <el-select v-model="form.platformId" placeholder="选择归属运行平台 ID" style="width: 100%" filterable @change="handleChangePlatformId">
                  <el-option v-for="item in platformData" :key="item.platformId" :label="item.platformId + ' - ' + item.name + ' [' + item.min + ',' + item.max + ')'" :value="item.platformId">
                    <span style="display: flex; align-items: center; gap: 8px;">
                      <span>{{ item.platformId }} - {{ item.name }} [{{ item.min }},{{ item.max }})</span>
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="32">
            <el-col :span="12">
              <el-form-item label="渠道ID" prop="id">
                <el-input v-model.number="form.id" :disabled="!isNew" placeholder="自定义分配渠道 ID" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账号渠道ID" prop="accountChannelId">
                <el-input v-model.number="form.accountChannelId" :disabled="form.status === 5" placeholder="关联账号渠道 ID" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="32">
            <el-col :span="12">
              <el-form-item label="渠道名称" prop="name">
                <el-input v-model.trim="form.name" placeholder="请输入渠道名称" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="status">
                <el-select v-model="form.status" placeholder="选择状态" style="width: 100%">
                  <el-option v-for="item in statusOption" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="32">
            <el-col :span="12">
              <el-form-item label="包类型" prop="packageType">
                <el-select v-model="form.packageType" placeholder="选择包物理性质" style="width: 100%" @change="handlePackageTypeChange">
                  <el-option v-for="item in packageTypes" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value">
                    <span style="display: flex; align-items: center; gap: 8px;">
                      <font-awesome-icon :icon="getOSIcon(item.value)" :style="{ color: getOSColor(item.value) }" />
                      <span>{{ item.value }} - {{ item.label }}</span>
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道类型" prop="channelType">
                <el-select v-model="form.channelType" placeholder="选择渠道类型" style="width: 100%">
                  <el-option v-for="item in channelTypeOptions" :key="item.id" :label="item.id + ' - ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="32">
            <el-col :span="12">
              <el-form-item label="切换用户" prop="shadowType">
                <el-select v-model.trim="form.shadowType" placeholder="请选择是否允许切换用户" style="width: 100%">
                  <el-option v-for="item in shadowTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="包名" prop="packageName">
                <el-input v-model="form.packageName" placeholder="请输入包名 packageName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="适龄" prop="minAge">
                <el-input-number v-model="form.minAge" :min="0" :max="100" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备案识别码" prop="bizId">
                <el-input v-model="form.bizId" placeholder="请输入备案识别码 bizId"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="停用引导文案">
                <el-input type="textarea" :rows="2" v-model="argsForm.workWxHtml" placeholder="如配置，当渠道注册关闭时展示引导信息（支持 HTML）" :disabled="argsReadOnly"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="七鱼groupId" prop="qyGroupId">
                <el-input v-model="form.qyGroupId" placeholder="请输入七鱼groupId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="七鱼appKey" prop="qyAppKey">
                <el-input v-model="form.qyAppKey" placeholder="请输入七鱼appKey"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 步骤 2 / 网关域名回调 (Gateway & Callback) -->
      <div v-if="currentStep === 1" class="tab-panel">
        <div class="panel-section-group">
          <div class="panel-section-header">
            <div class="panel-title-icon"><font-awesome-icon :icon="getStepIcon(currentStep)" /></div>
            <h3 class="panel-section-title">
              网关域名回调
            </h3>
            <p class="section-subtitle">配置网关回调规则与对接地址。</p>
          </div>
          <el-form :model="form" label-position="right" label-width="130px" :rules="rules" ref="formUrls" size="small" class="form-container">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="网关域名" prop="areaId">
                  <el-select v-model.number="form.areaId" placeholder="选择网关域名" style="width: 100%;" clearable>
                    <el-option v-for="area in areaData" :key="area.id" :label="area.id + ' - ' + area.name" :value="area.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="CP-NotifyUrl" prop="notifyUrl">
                  <el-input v-model.trim="form.notifyUrl" placeholder="自定义 NotifyUrl 支付回调地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="CP-H5Url" prop="h5LoginUrl">
                  <el-input v-model.trim="form.h5LoginUrl" placeholder="自定义 H5LoginUrl 快捷登录跳转地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="CP-微端Url" prop="gameUrl">
                  <el-input v-model.trim="form.gameUrl" placeholder="自定义 微端GameUrl 地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <!-- 步骤 3 / 防护开关控制 (Prevention & Switches) -->
      <div v-if="currentStep === 2" class="tab-panel">
        <div class="panel-section-group">
          <div class="panel-section-header">
            <div class="panel-title-icon"><font-awesome-icon :icon="getStepIcon(currentStep)" /></div>
            <h3 class="panel-section-title">
              防护开关控制
            </h3>
            <p class="section-subtitle">管理渠道的登录支付主开关及安全防护属性。</p>
          </div>
          <el-form :model="form" label-position="right" label-width="130px" size="small" class="form-container">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="登录开关" prop="loginOpen">
                  <el-switch v-model="form.loginOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付开关" prop="payOpen">
                  <el-switch v-model="form.payOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="注册开关" prop="registerOpen">
                  <el-switch v-model="form.registerOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="转端开关" prop="transferOpen">
                  <el-switch v-model="form.transferOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="防沉迷" prop="juvenileOpen">
                  <el-switch v-model="form.juvenileOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实名认证" prop="realAuthOpen">
                  <el-switch v-model="form.realAuthOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="手机号绑定" prop="phoneBindOpen">
                  <el-switch v-model="form.phoneBindOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约归因" prop="reserveAttributeOpen">
                  <el-switch v-model="form.reserveAttributeOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="卸载菜单栏" prop="uninstallMenuOpen">
                  <el-switch v-model="form.uninstallMenuOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Pluto" prop="plutoOpen">
                  <el-switch v-model="form.plutoOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="UFW" prop="ufwOpen">
                  <el-switch v-model="form.ufwOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="测试补单开关" prop="testRenotifyOpen">
                  <el-switch v-model="form.testRenotifyOpen" active-color="#10b981" inactive-color="#ef4444"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <!-- 步骤 4 / 商品档位映射 (Products) -->
      <div v-if="currentStep === 3" class="tab-panel">
        <div class="panel-section-group">
          <div class="panel-section-header">
            <div class="panel-title-icon"><font-awesome-icon :icon="getStepIcon(currentStep)" /></div>
            <h3 class="panel-section-title">商品计费档位映射</h3>
            <p class="section-subtitle">如开启自定义商品映射，支付网关会比对游戏计费点并转换为对应的渠道计费项。</p>
          </div>

          <el-form :model="argsForm" label-position="right" label-width="130px" size="small" class="form-container">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="自定义商品映射">
                  <el-switch v-model="argsForm.customized" active-color="#10b981" inactive-color="#ef4444" :disabled="productsReadOnly"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>

            <div v-show="argsForm.customized" class="channel-products-config">
              <div class="channel-products-currency">
                <el-form-item label="计费结算货币">
                  <el-select v-model="argsForm.currency" placeholder="请选择结算货币单位" filterable @change="currencyChange" :disabled="productsReadOnly">
                    <el-option v-for="item in currencyOptions" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="channel-products-section">
                <div class="panel-section-header">
                  <div class="panel-title-icon"><i class="el-icon-tickets"></i></div>
                  <div>
                    <h3 class="panel-section-title">商品挡位明细</h3>
                    <p class="section-subtitle">当前货币：{{ argsForm.currency || '-' }}</p>
                  </div>
                </div>

                <div class="channel-products-table-container">
                  <el-table :data="customizedForm.products" stripe class="premium-table channel-products-edit-table">
                    <el-table-column label="商品 ID" min-width="130">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.id" placeholder="商品ID" :disabled="scope.row.idLocked || productsReadOnly" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="价格（分）" width="130">
                      <template slot-scope="scope">
                        <el-input v-model.number="scope.row.price" placeholder="价格" :disabled="productsReadOnly" size="small" type="number"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品名称" min-width="150">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="商品名称" :disabled="productsReadOnly" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="商品描述" min-width="220">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.desc" placeholder="商品描述" :disabled="productsReadOnly" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="渠道商品 ID" min-width="170">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.cid" placeholder="渠道商品映射 ID" :disabled="productsReadOnly" size="small"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="76" align="center" fixed="right">
                      <template slot-scope="scope">
                        <el-button type="danger" size="mini" circle icon="el-icon-delete" plain @click="handleDeleteProductsParams(scope.$index)" :disabled="scope.row.isDefault || productsReadOnly"></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>

                <div class="channel-products-toolbar">
                  <el-button type="primary" size="small" icon="el-icon-plus" class="channel-products-primary-btn" @click="handleAddProductsParams" :disabled="productsReadOnly">添加单行</el-button>
                  <el-button size="small" icon="el-icon-download" plain @click="handleExportProductsTemplate">导出 Excel</el-button>
                  <el-upload action="" :auto-upload="false" :show-file-list="false" accept=".xlsx,.xls,.csv" :on-change="handleAddFile" class="channel-products-upload" :disabled="productsReadOnly">
                    <el-button size="small" icon="el-icon-upload2" plain :disabled="productsReadOnly">导入 Excel</el-button>
                  </el-upload>
                </div>
              </div>

              <div class="channel-products-section channel-products-json-section">
                <div class="panel-section-header channel-products-compact-header">
                  <div class="panel-title-icon"><i class="el-icon-document"></i></div>
                  <div>
                    <h3 class="panel-section-title">查看/编辑 JSON</h3>
                    <p class="section-subtitle">查看当前商品挡位 JSON，或切换到编辑模式后批量应用。</p>
                  </div>
                  <el-radio-group v-model="formatJson" size="mini" class="channel-products-json-switch" @change="handleProductJsonModeChange">
                    <el-radio-button :label="false">查看</el-radio-button>
                    <el-radio-button :label="true" :disabled="productsReadOnly">编辑</el-radio-button>
                  </el-radio-group>
                </div>

                <pre v-if="!formatJson" class="channel-products-json-preview">{{ formattedCustomizedProductsJson }}</pre>
                <div v-else class="channel-products-json-editor">
                  <el-input v-model="textarea" type="textarea" :rows="8" placeholder="请输入商品挡位 JSON 数组" class="channel-products-code-textarea" :disabled="productsReadOnly"></el-input>
                  <div class="channel-products-json-actions">
                    <el-button type="success" size="small" icon="el-icon-check" @click="handleFormatJson" :disabled="productsReadOnly">应用 JSON</el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 步骤 5 / 逻辑密钥参数 (Logic Params & Template) -->
      <div v-if="currentStep === 4" class="tab-panel">
        <div class="panel-section-group">
          <div class="panel-section-header">
            <div class="panel-title-icon"><font-awesome-icon :icon="getStepIcon(currentStep)" /></div>
            <h3 class="panel-section-title">
              逻辑密钥关联参数
            </h3>
            <p class="section-subtitle">绑定运行参数模板并维护密钥相关的动态配置。</p>
          </div>
          <el-form :model="argsForm" label-position="right" label-width="130px" :rules="argsRules" ref="argsForm" size="small" class="form-container">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="ArgsGroupId" prop="id">
                  <el-input v-model.number="form.argsGroupId" placeholder="配置运行参数唯一 ID" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="逻辑映射模板" prop="logicId">
                  <el-select v-model="argsForm.logicId" filterable placeholder="请关联网关对应的逻辑处理插件" style="width: 100%;" @change="handleChangeLogicArgs" clearable :disabled="argsReadOnly">
                    <el-option v-for="item in logicData" :key="item[0]" :label="item[0] + ' - ' + item[1].name + (item[1].status === 1 ? ' (已废弃)' : '')" :value="item[0]"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 动态参数列表 -->
            <div class="args-list-section box" v-if="argsForm.args && argsForm.args.length > 0" style="margin-top: 16px; border: 1px solid var(--border-light); background: var(--bg-hover); padding: 16px; border-radius: 8px;">
              <div class="args-section-title" style="font-weight: bold; margin-bottom: 12px; color: var(--primary-color); display: flex; justify-content: space-between; align-items: center;">
                <span><font-awesome-icon icon="tasks" style="margin-right: 6px;" />模板参数配置列表</span>
                <el-button type="primary" size="mini" icon="el-icon-magic-stick" @click="fillDefaultArgsValues" :disabled="argsReadOnly">填充参数</el-button>
              </div>
              <div class="args-list-body">
                <el-form-item v-for="(item, i) in argsForm.args" :key="i" :label="item.label" class="args-list-item" style="margin-bottom: 12px;">
                  <div class="args-input-row" style="display: flex; gap: 12px; align-items: center;">
                    <el-input v-model="item.value" placeholder="请输入配置值" style="flex: 1;" :disabled="argsReadOnly"></el-input>
                    <el-checkbox v-model="item.isKeep" v-if="item.show" style="margin-bottom: 0;" :disabled="argsReadOnly">保留已废弃</el-checkbox>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 步骤 6 / 登录支付折扣 (Official Login & Pay) -->
      <div v-if="currentStep === 5" class="tab-panel">
        <div class="panel-section-group">
          <div class="panel-section-header">
            <div class="panel-title-icon"><font-awesome-icon :icon="getStepIcon(currentStep)" /></div>
            <h3 class="panel-section-title">
              登录支付折扣
            </h3>
            <p class="section-subtitle">折扣绑定及官方通道专属参数配置。</p>
          </div>
          <el-form :model="form" label-position="right" label-width="130px" size="small" class="form-container">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="折扣率" prop="rate">
                  <el-select v-model="form.rate" placeholder="选择折扣率" style="width: 100%">
                    <el-option v-for="item in rateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="折扣类型" prop="discountType">
                  <el-select v-model.number="form.discountType" placeholder="选择折扣类型" style="width: 100%">
                    <el-option v-for="item in discountTypeList" :key="item.value" :label="item.value + ' - ' + item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24" v-if="isOfficialLogic">
              <el-col :span="12">
                <el-form-item label="XsLoginArgsId" prop="xsLoginArgsId">
                  <el-input v-model.number="form.xsLoginArgsId" placeholder="不配则默认使用游戏的登录配置"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="XsPayArgsId" prop="xsPayArgsId">
                  <el-input v-model.number="form.xsPayArgsId" placeholder="不配则默认使用游戏的支付配置"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>

          <!-- 官方登录支付参数明细的直属接入 (ArgsLogin & ArgsPay) -->
          <div v-if="!isNew && isOfficialLogic" style="margin-top: 30px;">
            <div style="border-top: 1px solid var(--border-color); padding-top: 24px; margin-top: 24px;">
              <el-row :gutter="24">
                <el-col :span="24">
                  <div class="logic-args-box" style="margin-bottom: 24px;">
                    <div style="font-weight: bold; margin-bottom: 12px; color: var(--text-muted); display: flex; align-items: center; gap: 8px;">
                      <font-awesome-icon icon="shield-alt" style="color: #2563EB;" />
                      <span>XsLogin 逻辑参数详情 (关联 ID: {{ form.xsLoginArgsId }})</span>
                    </div>
                    <xs-logic-args ref="xsLoginArgs" :key="'login_' + form.xsLoginArgsId" :owner-type="0" :args-id="Number(form.xsLoginArgsId)" :logic-type="1" :read-only="xsLoginReadOnly" v-if="form.xsLoginArgsId !== undefined && form.xsLoginArgsId !== null && form.xsLoginArgsId !== ''" />
                    <div v-else style="color: var(--text-muted); font-size: 13px; padding: 20px; border: 1px dashed var(--border-hover); border-radius: 6px; text-align: center; background: var(--bg-card);">
                      暂无关联 of XsLoginArgsId，无法配置逻辑登录参数
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="24">
                <el-col :span="24">
                  <div class="logic-args-box">
                    <div style="font-weight: bold; margin-bottom: 12px; color: var(--text-muted); display: flex; align-items: center; gap: 8px;">
                      <font-awesome-icon icon="credit-card" style="color: #10B981;" />
                      <span>XsPay 逻辑参数详情 (关联 ID: {{ form.xsPayArgsId }})</span>
                    </div>
                    <xs-logic-args ref="xsPayArgs" :key="'pay_' + form.xsPayArgsId" :owner-type="0" :args-id="Number(form.xsPayArgsId)" :logic-type="2" :read-only="xsPayReadOnly" v-if="form.xsPayArgsId !== undefined && form.xsPayArgsId !== null && form.xsPayArgsId !== ''" />
                    <div v-else style="color: var(--text-muted); font-size: 13px; padding: 20px; border: 1px dashed var(--border-hover); border-radius: 6px; text-align: center; background: var(--bg-card);">
                      暂无关联 of XsPayArgsId，无法配置逻辑支付参数
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 变更内容可视化确认弹窗 -->
    <el-dialog title="确认修改配置变更" :visible.sync="diffDialogVisible" width="600px" append-to-body>
      <div class="diff-dialog-body" style="max-height: 400px; overflow-y: auto; padding: 10px;">
        <p style="margin-top: 0; font-weight: bold; color: #374151; font-size: 14px; margin-bottom: 12px;">发现以下配置已变更，请核对：</p>
        <div v-if="diffLogs.length === 0" style="color: #9ca3af; text-align: center; padding: 20px;">
          无变更内容
        </div>
        <ul v-else style="padding-left: 20px; margin: 0; line-height: 1.8;">
          <li v-for="(log, index) in diffLogs" :key="index" style="margin-bottom: 8px; color: #1f2937; list-style-type: none;">
            <span v-if="log.startsWith('+')" style="color: #10b981; font-weight: bold; margin-right: 4px;">[新增]</span>
            <span v-else-if="log.startsWith('-')" style="color: #ef4444; font-weight: bold; margin-right: 4px;">[删除]</span>
            <span v-else-if="log.startsWith('~')" style="color: #f59e0b; font-weight: bold; margin-right: 4px;">[修改]</span>
            <span v-else style="color: #2563eb; font-weight: bold; margin-right: 4px;">[变更]</span>
            <span>{{ formatDiffLogText(log) }}</span>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: right;">
        <el-button @click="diffDialogVisible = false" size="medium">取消</el-button>
        <el-button type="primary" @click="handleConfirmSubmit" :loading="saving" size="medium">确认提交并保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable vue/component-name-in-template-casing, vue/no-unused-vars */
import api from '@/api/channel'
import options from '@/common/options'
import XsLogicArgs from '@/views/Xs/Args/LogicArgs.vue'

export default {
  name: 'ChannelDialog',
  components: {
    XsLogicArgs
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    step: {
      type: Number,
      default: 0
    },
    isDrawer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    // 校验规则
    const idRules = (rule, value, callback) => {
      let min = this.appId * 1000
      let max = (this.appId + 1) * 1000
      if (this.platformData.length) {
        for (const item of this.platformData) {
          if (item.platformId === this.form.platformId) {
            min = item.min
            max = item.max
          }
        }
      }
      if (value === '') {
        callback(new Error('此字段必填'))
      } else if (typeof (value) !== 'number') {
        callback(new Error('请输入数字'))
      } else if (value < 0) {
        callback(new Error('请输入有效数字'))
      } else if (value < min) {
        callback(new Error('应大于等于 ' + min))
      } else if (value >= max) {
        callback(new Error('应小于 ' + max))
      } else {
        callback()
      }
    }
    const packageTypeRules = (rule, value, callback) => {
      if (Number(value) <= 0) {
        callback(new Error('请选择包类型'))
      } else {
        callback()
      }
    }
    const channelTypeRules = (rule, value, callback) => {
      if (Number(value) <= 0) {
        callback(new Error('请选择渠道类型'))
      } else {
        callback()
      }
    }
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
    const urlRules = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback()
      } else if (!urlPattern.test(value)) {
        callback(new Error('URL 格式不正确'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      channelId: null,
      maxReachedStep: 0,
      diffDialogVisible: false,
      diffLogs: [],
      saving: false,
      initialForm: null,
      initialArgsForm: null,
      initialProducts: null,
      isCollapsed: false,

      // 统一进度条步骤
      currentStep: 0,
      steps: [
        { title: '基础属性', description: '平台及基础信息配置' },
        { title: '网关回调', description: '配置网关回调参数' },
        { title: '功能开关', description: '配置功能开关及能力' },
        { title: '商品档位', description: '配置计费档位及货币' },
        { title: '逻辑参数', description: '设置业务逻辑相关参数' },
        { title: '登录支付', description: '对接登录与支付配置' }
      ],

      logicData: new Map(),
      platformData: [],
      areaData: [],
      areaMap: new Map(),
      channelTypeList: [],
      channelTypeOptions: [],

      // 静态选项
      os: options.os,
      packageTypes: options.packageTypes,
      rateList: options.rateOption,
      discountTypeList: options.discountTypeOption,
      shadowTypes: options.shadowTypes,
      statusOption: options.statusOption,
      currencyOptions: options.currency,

      // 1. 基础属性表单
      form: {
        platformId: null,
        id: '',
        name: '',
        status: 0,
        accountChannelId: '',
        argsGroupId: '',
        shadowType: 0,
        packageType: 0,
        channelType: 0,
        os: '',
        notifyUrl: '',
        h5LoginUrl: '',
        gameUrl: '',
        realAuthOpen: false,
        phoneBindOpen: false,
        reserveAttributeOpen: false,
        juvenileOpen: false,
        plutoOpen: false,
        ufwOpen: true,
        minAge: 0,
        bizId: '',
        packageName: '',
        qyAppKey: '',
        qyGroupId: '',
        uninstallMenuOpen: false,
        loginOpen: true,
        payOpen: true,
        registerOpen: true,
        transferOpen: false,
        testRenotifyOpen: false,
        discountType: 0,
        rate: 0,
        areaId: 0,
        xsType: 0,
        xsLoginArgsId: '',
        xsPayArgsId: ''
      },

      // 2. 参数配置表单
      argsEditMode: false,
      argsForm: {
        id: '',
        logicId: '',
        workWxHtml: '',
        args: [],
        products: null,
        customized: false,
        currency: 'CNY'
      },

      // 3. 商品映射
      customizedForm: {
        products: []
      },
      textarea: '',
      formatJson: false,

      // 验证规则
      rules: {
        id: [{ type: 'number', required: true, validator: idRules, trigger: 'blur' }],
        name: [{ type: 'string', required: true, message: '请输入名称', trigger: 'blur' }],
        platformId: [{ type: 'number', required: true, message: '请选择平台 ID', trigger: 'change' }],
        accountChannelId: [{ type: 'number', required: true, validator: idRules, trigger: 'blur' }],
        argsGroupId: [{ type: 'number', required: true, validator: idRules, trigger: 'blur' }],
        packageType: [{ required: true, validator: packageTypeRules, trigger: 'change' }],
        channelType: [{ required: true, validator: channelTypeRules, trigger: 'change' }],
        notifyUrl: [{ validator: urlRules, trigger: 'blur' }],
        h5LoginUrl: [{ validator: urlRules, trigger: 'blur' }],
        gameUrl: [{ validator: urlRules, trigger: 'blur' }]
      },
      argsRules: {
        id: [{ type: 'number', required: true, message: '运行参数ID必填且必须为数字', trigger: 'blur' }],
        logicId: [{ type: 'number', required: true, message: '请选择逻辑模块模板', trigger: 'change' }]
      }
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    appInfo () {
      return this.$store.getters.appInfo
    },
    isNew () {
      return this.channelId === null
    },
    xsLoginReadOnly () {
      const val = Number(this.form.xsLoginArgsId)
      const currentId = Number(this.form.id)
      return isNaN(val) || isNaN(currentId) || val === 0 || val !== currentId
    },
    xsPayReadOnly () {
      const val = Number(this.form.xsPayArgsId)
      const currentId = Number(this.form.id)
      return isNaN(val) || isNaN(currentId) || val === 0 || val !== currentId
    },
    argsReadOnly () {
      const val = Number(this.form.argsGroupId)
      const currentId = Number(this.form.id)
      return isNaN(val) || isNaN(currentId) || val === 0 || val !== currentId
    },
    productsReadOnly () {
      const val = Number(this.form.argsGroupId)
      return isNaN(val) || val === 0
    },
    // 健康指标计算
    isOfficialLogic () {
      return Number(this.argsForm.logicId) === 133
    },
    healthStatus () {
      return {
        gateway: this.form.areaId > 0,
        args: this.argsEditMode && this.argsForm.logicId > 0,
        products: !this.argsForm.customized || (this.customizedForm.products && this.customizedForm.products.length > 0),
        switches: this.form.realAuthOpen && this.form.juvenileOpen
      }
    },
    formattedCustomizedProductsJson () {
      return JSON.stringify(this.getPersistChannelProducts(), null, 2)
    }
  },
  watch: {
    appId () {
      this.goBack()
    },
    'form.id' (val, oldVal) {
      if (val === oldVal || !this.isNew) return
      this.form.accountChannelId = val
      this.argsForm.id = val
      this.fillDefaultXsArgsIds()
    },
    'form.accountChannelId' (val, oldVal) {
      if (val === oldVal || !this.isNew) return
      this.form.argsGroupId = val
    },
    'form.xsType' (val) {
      if (Number(val) === 1) {
        this.fillDefaultXsArgsIds()
      }
    },
    currentStep (val) {
      this.maxReachedStep = Math.max(this.maxReachedStep, val)
    },
    'argsForm.customized' (val) {
      if (val && (!this.customizedForm.products || this.customizedForm.products.length === 0)) {
        this.initDefaultProducts()
      }
    },
    'form.argsGroupId' (val) {
      if (val !== undefined && val !== null && val !== '') {
        const numVal = Number(val)
        if (!isNaN(numVal)) {
          this.argsForm.id = numVal
        }
        if (!isNaN(numVal) && numVal > 0) {
          this.fetchArgsConfig(numVal)
        }
      }
    }
  },
  created () {
    let id = null
    if (this.isDrawer) {
      id = this.id
      this.currentStep = this.step !== undefined ? Number(this.step) : 0
    } else {
      id = this.$route.query.id
      if (this.$route.query.step) {
        this.currentStep = Number(this.$route.query.step)
      } else {
        this.currentStep = 0
      }
    }
    this.channelId = id ? Number(id) : null

    this.loading = true
    this.$store.dispatch('GetChannelTypeList').then((res) => {
      this.channelTypeList = res
      this.fetchCommonData().then(() => {
        if (!this.isNew) {
          this.fetchChannelDetail()
        } else {
          this.initNewForm()
          this.loading = false
        }
      })
    })
  },
  methods: {
    initDefaultProducts () {
      this.customizedForm.products = this.normalizeChannelProducts([])
    },
    normalizeChannelProducts (customProducts) {
      let defaults = []
      try {
        defaults = this.appInfo && this.appInfo.products
          ? (typeof this.appInfo.products === 'string' ? JSON.parse(this.appInfo.products) : this.appInfo.products)
          : []
      } catch (e) {
        console.error('初始化默认商品列表失败:', e)
      }
      const productMap = new Map((Array.isArray(defaults) ? defaults : []).map(item => [String(item.id), {
        id: String(item.id),
        price: item.price,
        name: item.name || '',
        desc: item.desc || '',
        cid: '',
        isDefault: true,
        idLocked: true
      }]))
      ;(Array.isArray(customProducts) ? customProducts : []).forEach(item => {
        if (!item || item.id === undefined || item.id === null) return
        const id = String(item.id)
        if (productMap.has(id)) {
          Object.assign(productMap.get(id), this.getEditableChannelProductFields(item))
        } else {
          productMap.set(id, Object.assign({}, item, { id, isDefault: false, idLocked: true }))
        }
      })
      return Array.from(productMap.values())
    },
    getEditableChannelProductFields (item) {
      const result = {}
      ;['price', 'name', 'desc', 'cid'].forEach(key => {
        if (item[key] !== undefined) result[key] = item[key]
      })
      return result
    },
    getPersistChannelProducts () {
      return (this.customizedForm.products || [])
        .filter(item => item.id !== undefined && item.id !== null && String(item.id).trim())
        .map(item => ({
          id: String(item.id),
          price: item.price,
          name: item.name || '',
          desc: item.desc || '',
          cid: item.cid || ''
        }))
    },
    mergeChannelProducts (incoming) {
      const products = this.customizedForm.products || []
      const oldMap = new Map(products.filter(item => item.id).map(item => [String(item.id), item]))
      const blankRows = products.filter(item => !item.id)
      ;(Array.isArray(incoming) ? incoming : []).forEach(item => {
        if (!item || item.id === undefined || item.id === null || !String(item.id).trim()) return
        const id = String(item.id).trim()
        if (oldMap.has(id)) {
          Object.assign(oldMap.get(id), this.getEditableChannelProductFields(item))
        } else {
          oldMap.set(id, Object.assign({}, item, { id, isDefault: false, idLocked: false }))
        }
      })
      this.customizedForm.products = Array.from(oldMap.values()).concat(blankRows)
    },
    getStepIcon (idx) {
      const icons = ['file-alt', 'link', 'shield-alt', 'table', 'key', 'credit-card']
      return icons[idx]
    },
    fillDefaultXsArgsIds () {
      if (Number(this.argsForm.logicId) === 133) {
        this.form.xsType = 1
      }
    },
    getOSIcon (type) {
      const map = {
        1: ['fab', 'android'],
        2: ['fab', 'apple'],
        3: 'globe',
        4: 'mobile-alt',
        5: 'atom',
        6: ['fab', 'windows']
      }
      return map[type] || 'cube'
    },
    getOSColor (type) {
      const map = {
        1: '#10b981',
        2: '#1e293b',
        3: '#3b82f6',
        4: '#a855f7',
        5: '#f59e0b',
        6: '#ef4444'
      }
      return map[type] || '#64748b'
    },
    fetchCommonData () {
      return Promise.all([
        api.getPlatformData(this.appId).then(res => { this.platformData = res }),
        api.getAreas().then(res => {
          this.areaData = [{ id: 0, name: '非自定义' }, ...res]
          this.areaMap = this.mapData(res)
        }),
        api.getLogicData().then(res => { this.logicData = this.mapData(res) })
      ])
    },
    fetchChannelDetail () {
      api.getChannelData(this.appId).then(res => {
        const list = res || []
        const current = list.find(c => c.id === this.channelId)
        if (current) {
          this.form = Object.assign(this.form, current)
          this.fillDefaultXsArgsIds()
          if (this.form.platformId !== undefined && this.form.platformId !== null && this.form.platformId !== '') {
            this.form.platformId = Number(this.form.platformId)
          }
          if (this.form.testRenotifyOpen === null || this.form.testRenotifyOpen === undefined) {
            this.form.testRenotifyOpen = false
          }
          this.channelTypeOptions = this.channelTypeList.filter(t => t.packageType === this.form.packageType) || []
          this.maxReachedStep = 5

          // 备份初始值
          this.initialForm = JSON.parse(JSON.stringify(this.form))

          this.fetchArgsConfig(this.form.argsGroupId)
        } else {
          this.$message.error('未找到该渠道详情信息')
          this.goBack()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    fetchArgsConfig (argsGroupId) {
      api.getArgs(argsGroupId).then(res => {
        if (res && res.id) {
          this.argsEditMode = true
          const data = Object.assign({}, res)
          if (data.logicId !== undefined && data.logicId !== null && data.logicId !== '') {
            data.logicId = Number(data.logicId)
          }
          data.args = JSON.parse(data.args)

          for (const item of this.logicData) {
            if (Number(item[0]) === Number(data.logicId)) {
              data.args = this.mapLogic(JSON.parse(item[1].args), data.args)
            }
          }

          const customizedProductData = data.products ? JSON.parse(data.products) : []
          this.customizedForm.products = this.normalizeChannelProducts(customizedProductData)
          this.argsForm = data
          this.fillDefaultXsArgsIds()

          // 备份初始值
          this.initialArgsForm = JSON.parse(JSON.stringify(this.argsForm))
          this.initialProducts = JSON.parse(JSON.stringify(this.customizedForm.products))
        } else {
          this.argsEditMode = false
          this.argsForm = {
            id: argsGroupId,
            logicId: '',
            workWxHtml: '',
            args: [],
            products: null,
            customized: false,
            currency: 'CNY'
          }
          this.customizedForm.products = this.normalizeChannelProducts([])

          // 备份初始值
          this.initialArgsForm = JSON.parse(JSON.stringify(this.argsForm))
          this.initialProducts = JSON.parse(JSON.stringify(this.customizedForm.products))
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    initNewForm () {
      api.getChannelData(this.appId).then(res => {
        const list = res || []
        const maxId = list.length ? list[list.length - 1].id : this.appId * 1000
        const initialId = maxId + 1
        this.form = {
          platformId: null,
          id: initialId,
          name: '',
          status: 0,
          accountChannelId: initialId,
          argsGroupId: initialId,
          shadowType: 0,
          packageType: 0,
          channelType: 0,
          os: '',
          notifyUrl: '',
          h5LoginUrl: '',
          gameUrl: '',
          realAuthOpen: false,
          phoneBindOpen: false,
          reserveAttributeOpen: false,
          juvenileOpen: false,
          plutoOpen: false,
          ufwOpen: true,
          minAge: 0,
          bizId: '',
          packageName: '',
          qyAppKey: '',
          qyGroupId: '',
          uninstallMenuOpen: false,
          loginOpen: true,
          payOpen: true,
          registerOpen: true,
          transferOpen: false,
          testRenotifyOpen: false,
          discountType: 0,
          rate: 0,
          areaId: 0,
          xsType: 0,
          xsLoginArgsId: 0,
          xsPayArgsId: 0
        }
        this.argsForm = {
          id: initialId,
          logicId: '',
          workWxHtml: '',
          args: [],
          products: null,
          customized: false,
          currency: 'CNY'
        }
        this.fillDefaultXsArgsIds()
        // 备份初始值
        this.initialForm = JSON.parse(JSON.stringify(this.form))
        this.initialArgsForm = JSON.parse(JSON.stringify(this.argsForm))
        this.initialProducts = []
      })
    },

    // 步骤名获取
    getStepName (step) {
      const stepNames = ['基础属性', '网关回调', '功能开关', '商品档位', '逻辑参数', '登录支付']
      return stepNames[step] || ''
    },

    // 步骤节点点击自由切换控制
    handleStepClick (idx) {
      if (this.isNew) {
        // 新增状态下，禁止超过已达最大步骤的跳跃
        if (idx > this.maxReachedStep) {
          this.$message.warning('请先按部就班录入前置表单')
          return
        }
      }
      this.currentStep = idx
    },

    prevStep () {
      if (this.currentStep > 0) this.currentStep--
    },
    nextStep () {
      this.validateCurrentStepForm().then(valid => {
        if (valid) {
          if (this.currentStep < 5) {
            this.currentStep++
          }
        } else {
          this.$message.error('当前步骤校验未通过，请检查输入')
        }
      })
    },

    // 新增提交保存 (统一一次性保存渠道与参数)
    validateFormRef (refName) {
      const formRef = this.$refs[refName]
      if (!formRef || typeof formRef.validate !== 'function') {
        return Promise.resolve(true)
      }
      return new Promise((resolve) => {
        formRef.validate(valid => resolve(valid))
      })
    },
    validateCurrentStepForm () {
      return new Promise((resolve) => {
        // 检查 ArgsGroupId 必填且不能为 0
        const argsGroupId = Number(this.form.argsGroupId)
        if (isNaN(argsGroupId) || argsGroupId === undefined || argsGroupId === null || this.form.argsGroupId === '' || argsGroupId === 0) {
          this.$message.error('ArgsGroupId 为必填项，且不能为 0！')
          return resolve(false)
        }
        // 检查引用的 ArgsGroupId 配置是否存在
        if (argsGroupId !== Number(this.form.id) && !this.argsEditMode) {
          this.$message.error(`引用的 ArgsGroupId [${this.form.argsGroupId}] 不存在，请重新输入或核对！`)
          return resolve(false)
        }
        if (this.currentStep === 0) {
          this.validateFormRef('form').then(resolve)
        } else if (this.currentStep === 1) {
          this.validateFormRef('formUrls').then(resolve)
        } else if (this.currentStep === 4) {
          this.validateFormRef('argsForm').then(resolve)
        } else {
          resolve(true)
        }
      })
    },
    validateAllForms () {
      const argsGroupId = Number(this.form.argsGroupId)
      if (isNaN(argsGroupId) || argsGroupId === undefined || argsGroupId === null || this.form.argsGroupId === '' || argsGroupId === 0) {
        this.$message.error('ArgsGroupId 为必填项，且不能为 0！')
        return Promise.resolve(false)
      }
      if (argsGroupId !== Number(this.form.id) && !this.argsEditMode) {
        this.$message.error(`引用的 ArgsGroupId [${this.form.argsGroupId}] 不存在，请核对！`)
        return Promise.resolve(false)
      }
      const checkForm = this.validateFormRef('form')
      const checkArgs = this.validateFormRef('argsForm')
      const checkUrls = this.validateFormRef('formUrls')
      return Promise.all([checkForm, checkArgs, checkUrls]).then(([f1, f2, f3]) => {
        return f1 && f2 && f3
      })
    },
    collectDiffLogs () {
      const logs = []

      // 1. 渠道基本信息对比
      if (this.initialForm) {
        const fieldLabels = {
          name: '渠道名称',
          platformId: '平台 ID',
          status: '状态',
          accountChannelId: '账号渠道 ID',
          argsGroupId: '参数组 ID',
          shadowType: '切换用户',
          packageType: '包类型',
          channelType: '渠道类型',
          os: 'OS',
          notifyUrl: 'CP-NotifyUrl',
          h5LoginUrl: 'CP-H5Url',
          gameUrl: 'CP-微端Url',
          areaId: '网关环境 ID',
          realAuthOpen: '实名认证',
          phoneBindOpen: '手机绑定',
          reserveAttributeOpen: '预约归因',
          juvenileOpen: '防沉迷',
          plutoOpen: 'Pluto',
          ufwOpen: 'UFW',
          minAge: '适龄',
          bizId: '备案识别码',
          packageName: '包名',
          qyAppKey: '七鱼 AppKey',
          qyGroupId: '七鱼 GroupId',
          uninstallMenuOpen: '卸载菜单栏',
          loginOpen: '登录开关',
          payOpen: '支付开关',
          registerOpen: '注册开关',
          transferOpen: '转端开关',
          testRenotifyOpen: '测试补单开关',
          discountType: '折扣类型',
          rate: '折扣率',
          xsLoginArgsId: 'XsLoginArgsId',
          xsPayArgsId: 'XsPayArgsId'
        }

        Object.keys(fieldLabels).forEach(key => {
          let origVal = this.initialForm[key]
          let newVal = this.form[key]

          if (origVal === null || origVal === undefined) origVal = ''
          if (newVal === null || newVal === undefined) newVal = ''

          if (String(origVal) !== String(newVal)) {
            let displayOrig = origVal
            let displayNew = newVal
            if (key === 'status') {
              displayOrig = this.getStatusLabel(origVal)
              displayNew = this.getStatusLabel(newVal)
            } else if (key === 'packageType') {
              const fOrig = this.packageTypes.find(t => t.value === origVal)
              const fNew = this.packageTypes.find(t => t.value === newVal)
              displayOrig = fOrig ? fOrig.label : origVal
              displayNew = fNew ? fNew.label : newVal
            }
            logs.push(`~ 渠道基础属性 [${fieldLabels[key]}]: “${displayOrig}” 变更为 “${displayNew}”`)
          }
        })
      }

      // 2. 渠道运行配置参数组对比
      if (this.initialArgsForm) {
        if (Number(this.initialArgsForm.logicId) !== Number(this.argsForm.logicId)) {
          logs.push(`~ 渠道参数模板 [逻辑映射模板]: 由 “${this.initialArgsForm.logicId}” 变更为 “${this.argsForm.logicId}”`)
        }
        if (this.initialArgsForm.workWxHtml !== this.argsForm.workWxHtml) {
          logs.push('~ 渠道参数模板 [停用引导文案]: 发生变更')
        }
        if (this.initialArgsForm.customized !== this.argsForm.customized) {
          logs.push(`~ 商品映射 [是否开启自定义映射]: 由 “${this.initialArgsForm.customized ? '是' : '否'}” 变更为 “${this.argsForm.customized ? '是' : '否'}”`)
        }

        const origArgs = this.initialArgsForm.args || []
        const newArgs = this.argsForm.args || []

        newArgs.forEach(item => {
          const origItem = origArgs.find(o => o.key === item.key)
          if (origItem) {
            if (item.value !== origItem.value) {
              logs.push(`~ 运行密钥参数 [${item.label || item.key}]: 由 “${origItem.value}” 变更为 “${item.value}”`)
            }
          } else {
            logs.push(`+ 新增密钥参数 [${item.label || item.key}]: 值设为 “${item.value}”`)
          }
        })

        origArgs.forEach(origItem => {
          const exists = newArgs.some(n => n.key === origItem.key)
          if (!exists) {
            logs.push(`- 废弃密钥参数 [${origItem.label || origItem.key}]`)
          }
        })
      }

      // 3. 自定义商品映射对比
      if (this.argsForm.customized) {
        const origProducts = this.initialProducts || []
        const newProducts = this.customizedForm.products || []

        newProducts.forEach(item => {
          if (!item.id) return
          const origItem = origProducts.find(o => o.id === item.id)
          if (origItem) {
            if (Number(item.price) !== Number(origItem.price) || item.name !== origItem.name || item.cid !== origItem.cid) {
              logs.push(`~ 商品映射变动 [商品ID ${item.id}]: 价格由 “${origItem.price}” 变为 “${item.price}”，渠道商品ID由 “${origItem.cid}” 变为 “${item.cid}”`)
            }
          } else {
            logs.push(`+ 新增商品映射 [商品ID ${item.id}]: 价格 “${item.price}”，渠道商品ID “${item.cid}”`)
          }
        })

        origProducts.forEach(origItem => {
          const exists = newProducts.some(n => n.id === origItem.id)
          if (!exists && origItem.id) {
            logs.push(`- 删除商品映射 [商品ID ${origItem.id}]`)
          }
        })
      }

      // 4. XS 登录和支付配置对比（XsType === 1 时由 refs 收集）
      if (!this.isNew && this.isOfficialLogic) {
        if (this.$refs.xsLoginArgs) {
          const loginDiffs = this.$refs.xsLoginArgs.getDisplayDiff()
          logs.push(...loginDiffs.map(l => l.startsWith('[') ? '~ ' + l : l))
        }
        if (this.$refs.xsPayArgs) {
          const payDiffs = this.$refs.xsPayArgs.getDisplayDiff()
          logs.push(...payDiffs.map(l => l.startsWith('[') ? '~ ' + l : l))
        }
      }

      return logs
    },
    formatDiffLogText (log) {
      if (log.startsWith('+') || log.startsWith('-') || log.startsWith('~')) {
        return log.substring(1).trim()
      }
      return log
    },
    showSaveConfirmDialog () {
      const logs = this.collectDiffLogs()
      if (logs.length === 0 && !this.isNew) {
        this.$message.info('配置未发生变更，无需保存')
        return
      }
      this.diffLogs = logs
      this.diffDialogVisible = true
    },
    handleSaveCurrentStepOnly () {
      this.validateCurrentStepForm().then(valid => {
        if (valid) {
          this.handleConfirmSubmit()
        } else {
          this.$message.error('当前表单校验未通过，请核对红色提示项')
        }
      })
    },
    handleCreateChannelAndArgs () {
      this.validateAllForms().then(valid => {
        if (valid) {
          this.handleConfirmSubmit()
        } else {
          this.$message.error('部分表单校验未通过，请检查前置步骤中的必填项')
        }
      })
    },
    async handleConfirmSubmit () {
      this.saving = true

      try {
        // --- 准备数据 ---
        this.fillDefaultXsArgsIds()
        const channelParams = Object.assign({}, this.form)
        channelParams.appId = this.appId
        if (channelParams.rate === null || channelParams.rate === undefined || channelParams.rate === '') channelParams.rate = 0
        if (channelParams.discountType === null || channelParams.discountType === undefined || channelParams.discountType === '') channelParams.discountType = 0
        delete channelParams.pcConfigJson
        delete channelParams.pcQrcodeLogin
        delete channelParams.pcWxQrcodeUrl
        delete channelParams.pcPayType
        delete channelParams.pcPayText
        delete channelParams.pcKeFuUrl

        const argsParams = Object.assign({}, this.argsForm)
        argsParams.id = channelParams.argsGroupId

        if (this.customizedForm.products && this.customizedForm.products.length > 0) {
          const arr = this.getPersistChannelProducts()
          if (argsParams.customized) {
            argsParams.products = arr.length > 0 ? JSON.stringify(arr) : null
          }
        } else {
          argsParams.products = null
        }

        const args = {}
        if (argsParams.args && argsParams.args.length > 0) {
          for (const item of argsParams.args) {
            args[item.key] = item.value
            if (Object.prototype.hasOwnProperty.call(item, 'isKeep') && !item.isKeep) {
              delete args[item.key]
            }
          }
        }
        argsParams.args = JSON.stringify(args)

        const logs = this.collectDiffLogs()
        const channelChanged = this.isNew || logs.some(log => log.includes('渠道基础属性'))
        const argsChanged = this.isNew || logs.some(log => log.includes('渠道参数模板') || log.includes('运行密钥参数') || log.includes('商品映射'))

        // --- 链式同步提交 ---

        // 1. 保存渠道基本元数据
        if (channelChanged) {
          try {
            if (this.isNew) {
              await api.addChannel(channelParams)
            } else {
              await api.changeChannel(channelParams)
            }
          } catch (err) {
            throw new Error(`保存渠道基本信息失败: ${err.message || err.msg || err || '网络异常'}`)
          }
        }

        // 2. 保存渠道配置参数组（密钥和商品档位）
        if (argsChanged) {
          try {
            if (this.isNew || !this.argsEditMode) {
              await api.addArgs(argsParams)
            } else {
              await api.changeArgs(argsParams)
            }
          } catch (err) {
            throw new Error(`保存渠道参数配置（含商品档位）失败: ${err.message || err.msg || err || '网络异常'}`)
          }
        }

        // 3. 保存 XS 登录和支付配置 (仅编辑模式下，且 XsType === 1 时由组件导出增量动作)
        if (!this.isNew && this.isOfficialLogic) {
          if (this.$refs.xsLoginArgs) {
            const { created, updated, deleted } = this.$refs.xsLoginArgs.getChanges()
            for (const id of deleted) {
              try {
                await api.deleteXsArgsLogin(id)
              } catch (err) {
                throw new Error(`删除 XS 官方登录参数配置行 [ID ${id}] 失败: ${err.message || err.msg || err || '网络异常'}`)
              }
            }
            for (const item of created) {
              try {
                await api.addXsArgsLogin(item)
              } catch (err) {
                throw new Error(`新增 XS 官方登录参数配置行 [模板ID ${item.logicId}] 失败: ${err.message || err.msg || err || '网络异常'}`)
              }
            }
            for (const item of updated) {
              try {
                await api.updateXsArgsLogin(item)
              } catch (err) {
                throw new Error(`更新 XS 官方登录参数配置行 [ID ${item.id}] 失败: ${err.message || err.msg || err || '网络异常'}`)
              }
            }
          }

          if (this.$refs.xsPayArgs) {
            const { created, updated, deleted } = this.$refs.xsPayArgs.getChanges()
            for (const id of deleted) {
              try {
                await api.deleteXsArgsPay(id)
              } catch (err) {
                throw new Error(`删除 XS 官方支付参数配置行 [ID ${id}] 失败: ${err.message || err.msg || err || '网络异常'}`)
              }
            }
            for (const item of created) {
              try {
                await api.addXsArgsPay(item)
              } catch (err) {
                throw new Error(`新增 XS 官方支付参数配置行 [模板ID ${item.logicId}] 失败: ${err.message || err.msg || err || '网络异常'}`)
              }
            }
            for (const item of updated) {
              try {
                await api.updateXsArgsPay(item)
              } catch (err) {
                throw new Error(`更新 XS 官方支付参数配置行 [ID ${item.id}] 失败: ${err.message || err.msg || err || '网络异常'}`)
              }
            }
          }
        }

        // --- 保存成功后续处理 ---
        this.$message.success('配置已一站式成功保存！')
        this.diffDialogVisible = false

        if (this.isDrawer) {
          this.$emit('save-success')
        } else {
          this.goBack()
        }
      } catch (error) {
        console.error('一站式保存遇到异常:', error)
        this.$alert(error.message || '一站式保存出错，请核对后重试。', '保存中断提示', {
          confirmButtonText: '确定',
          type: 'error'
        })
      } finally {
        this.saving = false
      }
    },

    handleChangePlatformId (platformId) {
      const found = this.platformData.find(item => item.platformId === platformId)
      if (found) {
        this.form.platformId = found.platformId
      }
    },
    handlePackageTypeChange (val) {
      const item = this.packageTypes.find(t => t.value === val)
      if (item) {
        this.form.os = item.os
      }
      this.channelTypeOptions = this.channelTypeList.filter(t => t.packageType === val) || []
      if (!this.channelTypeOptions.find(t => t.id === this.form.channelType)) {
        this.form.channelType = 0
      }
    },
    handleChangeLogicArgs (id) {
      const template = this.logicData.get(Number(id))
      if (Number(id) === 133) {
        this.fillDefaultXsArgsIds()
      }
      if (template) {
        this.argsForm.args = JSON.parse(template.args)
      } else {
        this.argsForm.args = []
      }
    },

    // 商品映射操作
    handleAddProductsParams () {
      const item = { id: '', name: '', price: 0, desc: '', cid: '', isDefault: false, idLocked: false }
      if (!this.customizedForm.products) {
        this.customizedForm.products = []
      }
      this.customizedForm.products.push(item)
    },
    handleDeleteProductsParams (i) {
      if (this.customizedForm.products[i] && this.customizedForm.products[i].isDefault) {
        return this.$message.warning('游戏默认商品不允许删除')
      }
      this.customizedForm.products.splice(i, 1)
    },
    handleAddTextarea () {
      this.formatJson = !this.formatJson
    },
    handleProductJsonModeChange (isEdit) {
      if (isEdit) {
        this.textarea = this.formattedCustomizedProductsJson
      }
    },
    handleFormatJson () {
      if (!this.textarea) return this.$message.info('请输入数据')
      try {
        const obj = JSON.parse(this.textarea)
        if (Array.isArray(obj)) {
          this.mergeChannelProducts(obj)
          this.$message.success('JSON 计费点解析导入成功')
          this.formatJson = false
        } else {
          this.$message.error('格式必须为 JSON 数组')
        }
      } catch (e) {
        this.$message.error('JSON 格式有误，请查验符号')
      }
    },
    handleAddFile (uploadFile) {
      if (!uploadFile || !uploadFile.raw) return
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = e.target.result
          const XLSX = require('xlsx')
          const workbook = XLSX.read(data, { type: 'array' })
          const worksheet = workbook.Sheets[workbook.SheetNames[0]]

          const excelData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['id', 'price', 'name', 'desc', 'cid'], range: 1
          })
          excelData.forEach(row => {
            if (row.id !== undefined && row.id !== null) row.id = String(row.id).trim()
            if (row.price !== undefined && row.price !== null) row.price = Number(row.price)
          })

          this.mergeChannelProducts(excelData)
          this.$message.success('Excel 数据导入成功')
        } catch (error) {
          console.error(error)
        }
      }
      reader.readAsArrayBuffer(uploadFile.raw)
    },
    handleExportProductsTemplate () {
      const XLSX = require('xlsx')
      const products = this.getPersistChannelProducts()
      const worksheet = XLSX.utils.json_to_sheet([
        { id: '商品ID', price: '价格（分）', name: '商品名称', desc: '商品描述', cid: '渠道商品ID' },
        ...(products.length ? products : [{ id: '101', price: 600, name: '6元礼包', desc: '示例描述', cid: 'channel_product_6' }])
      ], { skipHeader: true })
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '商品挡位')
      XLSX.writeFile(workbook, `渠道商品挡位-${this.argsForm.currency || 'CNY'}.xlsx`)
    },
    currencyChange (val) {
      const params = { appId: this.appId, currency: val }
      api.getCurrencyData(params).then(res => {
        if (res && res.products) {
          this.customizedForm.products = this.normalizeChannelProducts(JSON.parse(res.products))
        } else {
          this.customizedForm.products = this.normalizeChannelProducts([])
        }
      })
    },
    goBack () {
      if (this.isDrawer) {
        this.$emit('close')
      } else {
        this.$router.push('/c/cl')
      }
    },
    getStatusLabel (val) {
      const found = this.statusOption.find(item => item.value === val)
      return found ? found.label : val
    },
    getStatusClass (status) {
      if (status === 5) return 'online'
      if (status === 3 || status === 4) return 'testing'
      if (status === -1) return 'closed'
      return 'developing'
    },
    mapLogic (arr, obj) {
      const arrMap = new Map()
      arr.forEach(item => {
        arrMap.set(item.key, item)
        item.value = obj[item.key]
      })
      for (const item in obj) {
        if (!arrMap.has(item)) {
          arr.push({ key: item, value: obj[item], label: item, isKeep: true, show: true })
        }
      }
      return arr
    },
    mapData (value) {
      const data = new Map()
      value.forEach(item => data.set(item.id, item))
      return data
    },
    fillDefaultArgsValues () {
      if (!this.argsForm.logicId) {
        this.$message.warning('请先选择逻辑映射模板')
        return
      }
      const template = this.logicData.get(Number(this.argsForm.logicId))
      if (!template || !template.args) {
        this.$message.warning('当前模板无配置参数')
        return
      }
      try {
        const defaultArgs = JSON.parse(template.args)
        let filledCount = 0
        this.argsForm.args.forEach(item => {
          if (item.value === undefined || item.value === null || String(item.value).trim() === '') {
            const matched = defaultArgs.find(d => d.key === item.key)
            if (matched && matched.value !== undefined && matched.value !== null && String(matched.value).trim() !== '') {
              item.value = matched.value
              filledCount++
            }
          }
        })
        if (filledCount > 0) {
          this.$message.success(`成功填充 ${filledCount} 个空白参数默认值`)
        } else {
          this.$message.info('未检测到需要填充的空白参数')
        }
      } catch (e) {
        console.error('解析模板默认参数失败:', e)
        this.$message.error('解析模板默认参数失败')
      }
    }
  }
}
</script>

<style scoped>
.detail-workspace {
  padding: 12px;
}

/* 顶部导航面包屑 */
.breadcrumb-header {
  position: sticky;
  top: 0;
  z-index: 100;
  align-items: center;
  margin-bottom: 16px;
  background: #ffffff;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
}

.btn-back {
  margin-right: 16px;
  border-radius: 6px;
}

.header-title {
  font-size: 16px;
  font-weight: 700;
  color: #18181b;
}

.header-subtitle {
  margin-left: 12px;
  font-size: 12.5px;
  color: #71717a;
  background: #f4f4f5;
  padding: 2px 8px;
  border-radius: 4px;
}

/* 统一进度条 Steps 设计美化 */
.wizard-steps-card {
  margin-left: 16px;
  margin-right: 16px;
  padding: 12px 16px;
  background: #FFFFFF;
  border-radius: var(--border-radius-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

/* 步骤条重构为水平左对齐 SaaS 双行视觉 */
.premium-steps :deep(.el-step) {
  flex-basis: 25% !important;
}

.premium-steps :deep(.el-step__icon) {
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
  font-weight: 700;
  transition: all 0.2s ease;
  border-width: 2px !important;
}

.premium-steps :deep(.el-step__title) {
  font-size: 14px;
  font-weight: 600;
  color: #64748B;
  line-height: 1.4;
  margin-top: 2px;
}

.premium-steps :deep(.el-step__description) {
  font-size: 11px;
  color: #94A3B8;
  line-height: 1.4;
  margin-top: 4px;
}

/* 激活状态 */
.premium-steps :deep(.el-step__head.is-process) {
  color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}
.premium-steps :deep(.el-step__head.is-process) .el-step__icon {
  background-color: var(--primary-color) !important;
  color: #FFFFFF !important;
  border-color: var(--primary-color) !important;
}
.premium-steps :deep(.el-step__title.is-process) {
  color: #1E293B !important;
  font-weight: 700;
}
.premium-steps :deep(.el-step__description.is-process) {
  color: #64748B !important;
}

/* 完成状态 */
.premium-steps :deep(.el-step__head.is-success) {
  color: #10B981 !important;
  border-color: #10B981 !important;
}
.premium-steps :deep(.el-step__head.is-success) .el-step__icon {
  background-color: rgba(16, 185, 129, 0.08) !important;
  color: #10B981 !important;
  border-color: #10B981 !important;
}
.premium-steps :deep(.el-step__title.is-success) {
  color: #1E293B !important;
}
.premium-steps :deep(.el-step__description.is-success) {
  color: #64748B !important;
}

/* 连接线 */
.premium-steps :deep(.el-step__line) {
  background-color: #E2E8F0 !important;
  height: 2px !important;
  top: 15px !important;
  margin-right: 12px !important;
}

/* 点击自由切换支持 */
.clickable-step {
  cursor: pointer;
}

.clickable-step :deep(.el-step__head) {
  transition: all 0.25s ease;
}

.clickable-step:hover :deep(.el-step__icon) {
  border-color: var(--primary-color) !important;
  color: var(--primary-color) !important;
  background: rgba(37, 99, 235, 0.06) !important;
}

.clickable-step:hover :deep(.el-step__title) {
  color: var(--primary-color) !important;
}

/* 详情头部导航 */
.breadcrumb-header {
  position: sticky;
  top: 0;
  z-index: 100;
  margin-bottom: 16px;
  background-color: #FFFFFF;
  padding: 10px 16px;
  border-radius: var(--border-radius-card);
  border: 1px solid #E2E8F0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.header-top-row {
  align-items: center;
}

.header-left {
  align-items: center;
  gap: 16px;
}

.btn-back {
  background-color: #FFFFFF !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.btn-back:hover {
  background-color: #F8FAFC !important;
  color: var(--text-main) !important;
  border-color: #CBD5E1 !important;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: #1E293B;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.header-title-icon {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: #2563EB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

/* 状态 */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
}

.status-badge .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-badge.online {
  color: #10b981;
  background-color: rgba(16, 185, 129, 0.08);
}
.status-badge.online .dot {
  background-color: #10b981;
}

.status-badge.testing {
  color: #d97706;
  background-color: rgba(245, 158, 11, 0.08);
}
.status-badge.testing .dot {
  background-color: #f59e0b;
}

.status-badge.developing {
  color: var(--primary-color);
  background-color: rgba(37, 99, 235, 0.08);
}
.status-badge.developing .dot {
  background-color: var(--primary-color);
}

.status-badge.closed {
  color: #dc2626;
  background-color: rgba(239, 68, 68, 0.08);
}
.status-badge.closed .dot {
  background-color: #ef4444;
}

/* 内容主框 */
.detail-content {
  margin-left: 16px;
  margin-right: 16px;
  padding: 20px 24px;
  background: #ffffff;
  border-radius: var(--border-radius-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
  min-height: 480px;
  margin-bottom: 20px; /* 移除了底栏后调小底边距 */
}

/* 步骤板块高级标题 */
.panel-section-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F1F5F9;
  display: grid !important;
  grid-template-columns: 36px minmax(0, 1fr);
  column-gap: 12px;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  width: 100%;
}

.panel-title-icon {
  grid-column: 1;
  grid-row: 1 / span 2;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  border: 1px solid rgba(37, 99, 235, 0.16);
  color: #2563EB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.panel-section-header > .panel-title-icon + div {
  grid-column: 2;
}

.panel-section-header > .panel-section-title {
  grid-column: 2;
  grid-row: 1;
}

.panel-section-header > .section-subtitle {
  grid-column: 2;
  grid-row: 2;
}

.section-main-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1E293B;
  display: flex;
  align-items: center;
}

.step-num-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--primary-color);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  margin-right: 10px;
}

.step-args { background: #6366f1; }
.step-products { background: #10b981; }
.step-urls { background: #f59e0b; }

.section-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #64748B;
}

.panel-section-title {
  position: relative;
  padding-left: 0;
  font-size: 16px;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.panel-section-title::before {
  display: none;
}

.text-indigo { color: #6366f1; }
.text-primary { color: #2563eb; }
.text-success { color: #10b981; }
.text-orange { color: #f59e0b; }

/* 链路拓扑自检 */
.health-flow-wrapper {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.flow-svg {
  width: 100%;
  max-width: 720px;
  height: 140px;
}

.flow-node {
  cursor: pointer;
}

.flow-node .node-bg {
  fill: #ffffff;
  stroke: #E2E8F0;
  stroke-width: 2.5;
  transition: all 0.3s ease;
}

.flow-node:hover .node-bg {
  stroke: var(--primary-color);
  fill: #F8FAFC;
}

.node-icon-html {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748B;
  font-size: 13.5px;
  pointer-events: none;
}

.flow-node.active .node-bg {
  stroke: #10b981;
}

.flow-node.active .node-icon-html {
  color: #10b981;
}

.node-pulse {
  fill: none;
  stroke-width: 1.5;
  opacity: 0;
  pointer-events: none;
}

.node-pulse.green { stroke: #10b981; animation: flow-pulse 2s infinite; }
.node-pulse.orange { stroke: #f59e0b; animation: flow-pulse 2s infinite; }
.node-pulse.red { stroke: #ef4444; animation: flow-pulse 2s infinite; }

@keyframes flow-pulse {
  0% { transform: scale(0.95); opacity: 0.6; transform-origin: center; }
  70% { transform: scale(1.15); opacity: 0; transform-origin: center; }
  100% { transform: scale(0.95); opacity: 0; transform-origin: center; }
}

.flow-animation-line {
  animation: flow-dash 10s linear infinite;
}

@keyframes flow-dash {
  to { stroke-dashoffset: -200; }
}

.node-text {
  font-size: 11px;
  font-weight: 600;
  fill: #1E293B;
  text-anchor: middle;
}

.node-status {
  font-size: 10.5px;
  font-weight: 700;
  text-anchor: middle;
}

.node-status.green { fill: #10b981; }
.node-status.orange { fill: #d97706; }
.node-status.red { fill: #ef4444; }

/* 页面表单宽度限制 */
.form-container {
  max-width: 800px;
}

.form-container :deep(.el-input__inner),
.form-container :deep(.el-textarea__inner) {
  border-radius: 8px;
  border-color: #E2E8F0;
  transition: all 0.2s ease;
}

.form-container :deep(.el-form-item__label) {
  text-align: left;
}

.form-container :deep(.el-input__inner:hover),
.form-container :deep(.el-textarea__inner:hover) {
  border-color: #CBD5E1;
}

.form-container :deep(.el-input__inner:focus),
.form-container :deep(.el-textarea__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.action-bar-content {
  max-width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bar-left-info {
  font-size: 13.5px;
  color: #64748B;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.bar-left-info::before {
  content: "";
  display: none; /* 去除蓝色圆点 */
}

.bar-right-buttons {
  display: flex;
  gap: 12px;
}

/* 自定义商品挡位：与游戏管理商品挡位编辑区保持一致 */
.channel-products-config {
  margin-top: 10px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.channel-products-currency {
  max-width: 520px;
}

.channel-products-currency :deep(.el-select) {
  width: 100%;
}

.channel-products-section {
  padding: 18px 0 20px;
  border-bottom: 1px solid #e2e8f0;
}

.channel-products-section:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.channel-products-table-container {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.channel-products-edit-table {
  color: #334155 !important;
  font-size: 13px !important;
}

.channel-products-edit-table :deep(.el-table__header-wrapper) th {
  padding: 9px 0 !important;
  border-bottom: 1px solid #e2e8f0 !important;
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-weight: 700 !important;
}

.channel-products-edit-table :deep(.el-table__row) td {
  padding: 7px 0 !important;
}

.channel-products-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.channel-products-upload {
  display: inline-block;
}

.channel-products-primary-btn {
  border-color: var(--primary-color) !important;
  border-radius: 8px !important;
  background-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.channel-products-primary-btn:hover,
.channel-products-primary-btn:focus {
  border-color: var(--primary-hover) !important;
  background-color: var(--primary-hover) !important;
}

.channel-products-compact-header {
  align-items: flex-start;
  grid-template-columns: 36px minmax(0, 1fr) auto !important;
}

.channel-products-json-switch {
  grid-column: 3;
  grid-row: 1 / span 2;
  flex-shrink: 0;
  margin-left: auto;
}

.channel-products-json-preview {
  min-height: 120px;
  max-height: 320px;
  overflow: auto;
  margin: 0;
  padding: 14px;
  border-radius: 8px;
  background: #0f172a;
  color: #e2e8f0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.channel-products-code-textarea :deep(.el-textarea__inner) {
  border-color: #e2e8f0;
  background-color: #ffffff;
  color: #1e293b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
}

.channel-products-json-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

/* 参数相关 */
.args-list-section, .custom-products-section {
  margin-top: 24px;
  border-top: 1px dashed #E2E8F0;
  padding-top: 20px;
}

.args-section-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #1E293B;
  margin-bottom: 16px;
}

.args-list-body {
  max-height: 350px;
  overflow-y: auto;
  padding-right: 12px;
}

.args-list-body::-webkit-scrollbar {
  width: 4px;
}
.args-list-body::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 2px;
}

.args-list-item {
  margin-bottom: 14px !important;
}

.args-input-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.args-keep-chk {
  flex-shrink: 0;
}

/* 商品映射网格 */
.products-grid-header {
  font-weight: bold;
  background: #F8FAFC;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  color: #475569;
  margin-bottom: 10px;
  border: 1px solid #E2E8F0;
}

.products-scroll-list {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.products-scroll-list::-webkit-scrollbar {
  width: 4px;
}
.products-scroll-list::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 2px;
}

.product-grid-row {
  align-items: center;
  gap: 10px;
}

.col-3 { width: 12%; }
.col-5 { width: 22%; }
.text-center { text-align: center; }

.products-action-row {
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}

.upload-btn-wrapper {
  margin-left: 10px;
  display: inline-block;
}

.json-import-box {
  margin-top: 16px;
  background: #F8FAFC;
  padding: 18px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
}

.import-textarea {
  margin-bottom: 10px;
}

/* 自研卡片步骤向导 UI 样式 */
.custom-wizard-steps {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  background-color: #FFFFFF;
  box-sizing: border-box;
}

.custom-step-node {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0; /* 允许在空间不足时收缩，防止超出内容区域 */
}

.custom-step-node:last-child {
  flex: 0 0 auto;
}

/* 步骤主体：包含左侧圆圈与右侧图标字样组合 */
.custom-step-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

/* 步骤数字圆圈：支持 inactive, active, finished */
.custom-step-number {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid #E2E8F0;
  background-color: #FFFFFF;
  color: #94A3B8;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  user-select: none;
}

.custom-step-node.active .custom-step-number {
  border-color: #2563EB;
  background-color: #2563EB;
  color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.custom-step-node.finished .custom-step-number {
  border-color: #10B981;
  background-color: #10B981;
  color: #FFFFFF;
}

/* 步骤主体小卡片包裹层 */
.custom-step-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  background-color: #FFFFFF;
  border: 1px solid transparent;
  transition: all 0.3s ease;
  min-width: 0;
}

.custom-step-node.active .custom-step-card-wrapper {
  background-color: transparent !important;
  border-color: transparent !important;
}

/* 文字排布 */
.custom-step-text-box {
  display: flex;
  flex-direction: column;
  text-align: center;
  min-width: 0;
}

.custom-step-title {
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  line-height: 1.3;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.custom-step-node.active .custom-step-title {
  color: #1E293B;
  font-weight: 700;
}

.custom-step-node.finished .custom-step-title {
  color: #1E293B;
}

.custom-step-desc {
  font-size: 11px;
  color: #94A3B8;
  line-height: 1.3;
  margin-top: 2px;
  font-weight: normal;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.custom-step-node.active .custom-step-desc,
.custom-step-node.finished .custom-step-desc {
  color: #64748B;
}

/* 虚线连接线：在步骤与步骤之间拉伸 */
.custom-step-line {
  flex: 1;
  height: 0;
  border-top: 1.5px dashed #CBD5E1;
  margin: 0 10px;
  min-width: 12px;
  transition: all 0.3s ease;
}

/* 允许点击的 hover 样式 */
.custom-step-node.clickable {
  cursor: pointer;
}
.custom-step-node.clickable:hover .custom-step-card-wrapper {
  background-color: var(--bg-hover);
  border-radius: 8px;
}

/* 抽屉模式特有样式覆盖 */
.is-drawer-workspace {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
  background-color: var(--bg-page);
}
.is-drawer-workspace .breadcrumb-header {
  margin: 0;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-top: none;
  padding: 12px 20px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  box-shadow: none;
}

.is-drawer-workspace .wizard-steps-card,
.is-drawer-workspace .detail-content {
  margin-left: 12px;
  margin-right: 12px;
}

.is-drawer-workspace .detail-content {
  flex: 1;
  overflow-y: auto;
  padding: 18px 20px;
}

.is-drawer-workspace .form-container {
  max-width: none;
  width: 100%;
}

.is-drawer-workspace .form-container :deep(.el-row) {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.is-drawer-workspace .form-container :deep(.el-col) {
  float: none;
  width: 100%;
  max-width: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.is-drawer-workspace .form-container :deep(.el-form-item) {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.is-drawer-workspace .form-container :deep(.el-form-item__label) {
  flex: 0 0 25%;
  width: 25% !important;
  min-width: 112px;
  max-width: 180px;
  padding-right: 16px;
  line-height: 32px;
  color: var(--text-muted);
  font-weight: 600;
}

.is-drawer-workspace .form-container :deep(.el-form-item__content) {
  flex: 1 1 75%;
  margin-left: 0 !important;
  min-width: 0;
}

.is-drawer-workspace .form-container :deep(.el-input-number),
.is-drawer-workspace .form-container :deep(.el-select) {
  width: 100%;
}

@media (max-width: 1280px) {
  .custom-step-line {
    margin: 0 6px;
    min-width: 8px;
  }

  .custom-step-card-wrapper {
    padding: 8px;
  }

  .custom-step-title {
    max-width: 88px;
  }
}

/* ==========================================================================
   深色模式特异性样式覆盖 (解决局部组件Scoped样式隔离引起的白底噪点)
   ========================================================================== */
html.dark .breadcrumb-header {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  box-shadow: none !important;
}
html.dark .wizard-steps-card {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}
html.dark .header-title {
  color: var(--text-main) !important;
}
html.dark .btn-back {
  background-color: var(--bg-page) !important;
  border-color: var(--border-color) !important;
  color: var(--text-main) !important;
}
html.dark .btn-back:hover {
  background-color: var(--bg-hover) !important;
  border-color: var(--border-hover) !important;
}
html.dark .premium-steps :deep(.el-step__title.is-process),
html.dark .premium-steps :deep(.el-step__title.is-success) {
  color: var(--text-main) !important;
}
html.dark .custom-step-card-wrapper {
  background-color: transparent !important;
}
/* 步骤节点的背景和标题色 */
html.dark .custom-step-node .custom-step-title {
  color: var(--text-muted) !important;
}
html.dark .custom-step-node.active .custom-step-title,
html.dark .custom-step-node.finished .custom-step-title {
  color: var(--text-main) !important;
}
html.dark .custom-step-desc {
  color: var(--text-muted) !important;
}
html.dark .custom-step-node.active .custom-step-desc,
html.dark .custom-step-node.finished .custom-step-desc {
  color: var(--text-main) !important;
}
html.dark .custom-step-line {
  border-top-color: var(--border-color) !important;
}
html.dark .custom-step-number {
  background-color: var(--bg-page) !important;
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
}
html.dark .custom-step-node.active .custom-step-number {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: #FFFFFF !important;
}
html.dark .custom-step-node.finished .custom-step-number {
  background-color: rgba(16, 185, 129, 0.12) !important;
  border-color: #10B981 !important;
  color: #10B981 !important;
}

/* 加上步骤向导容器的去白底暗色模式覆盖 */
html.dark .custom-wizard-steps {
  background-color: transparent !important;
}
html.dark .channel-products-code-textarea :deep(.el-textarea__inner) {
  background-color: var(--bg-page) !important;
  border-color: var(--border-color) !important;
  color: var(--text-main) !important;
}

</style>
